import React from "react";
import { Button } from "reactstrap";
import ManagedAccountTncConsent from "../../BusinessV2/ManagedAccountTncConsent";
import { MANAGED_ACCOUNT_TNC_DOCS, areAllManagedAccountTncAccepted } from "../../BusinessV2/managedAccountTnc";
import SignPad from "./SignPad";

// Individual Plus broker completion-link Terms step (D3 = per-doc, mirroring business).
// The client accepts the 7 managed-account TnC documents (one checkbox each, all required),
// confirms their broker-entered name (READ-ONLY), and signs (required). There is NO
// beneficial-owner certification for a lone individual. This component is presentational:
// `acceptedDocs` + `data.customerSign` are owned by the parent (UboDashboard individual
// branch), which persists them via /api/individual-lite/update-field (D1/D2).
const fullName = (data) => [data?.firstName, data?.middleName, data?.lastName]
  .map((part) => String(part || "").trim())
  .filter(Boolean)
  .join(" ");

const IndividualManagedAccountTerms = ({
  data = {},
  acceptedDocs = [],
  onToggleDoc = () => { },
  onSignatureChange = () => { },
  onSubmit = () => { },
  loading = false,
  showError = false,
}) => {
  const allAccepted = areAllManagedAccountTncAccepted(acceptedDocs);
  const hasSignature = Boolean(data?.customerSign);
  const canSubmit = allAccepted && hasSignature && !loading;

  return (
    <div className="business-v2-step-section fv_ubo_individual_terms" data-testid="individual-ma-terms">
      <ManagedAccountTncConsent
        documents={MANAGED_ACCOUNT_TNC_DOCS}
        acceptedDocs={acceptedDocs}
        onToggle={onToggleDoc}
        disabled={loading}
        showError={showError && !allAccepted}
        error="Please read and accept all documents to continue."
      />

      <div>
        <label className="fw-bold d-block mb-2">Signature <span className="text-danger">*</span></label>
        <SignPad id="individual-ma-sign" value={data?.customerSign || ""} onChange={onSignatureChange} style={{ margin: 0 }} />
        {showError && !hasSignature ? (
          <div className="ps-0 mt-1 error__message" data-testid="individual-ma-sign-error">Signature is required.</div>
        ) : null}
      </div>

      <div>
        <label className="fw-bold d-block mb-1">Name</label>
        <div data-testid="individual-ma-terms-name">{fullName(data) || "—"}</div>
      </div>

      <div className="d-flex justify-content-end">
        <Button
          className="form-content-btn"
          onClick={onSubmit}
          disabled={!canSubmit}
          data-testid="individual-ma-terms-submit"
        >
          {loading ? "Saving…" : "Accept & Continue"}
        </Button>
      </div>
    </div>
  );
};

export default IndividualManagedAccountTerms;
